import * as keymap from 'prosemirror-keymap';
import * as history from 'prosemirror-history';
import { findestKeymap } from "Components/Shared/Markdown/ProseMirrorEditor/FindestKeymap";

export class ProseMirrorPluginController {

    public getDefault() {
        return [history.history(), keymap.keymap(findestKeymap)];
    }
}

export const ProseMirrorPluginControllerSingleton = new ProseMirrorPluginController();